module.exports = __webpack_public_path__ + "static/img/11.722c6b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/11.png
// module id = YtpD
// module chunks = 0